<template>
    <CompassModal
        v-model:visible="showModal"
        size="medium"
        :title="title"
        class="counter-draft-form"
        @closed="$emit('close-popup')"
    >
        <template #default>
            <div class="dialog__default">
                <p class="grey mb-2 typographies-paragraph-medium-regular">{{ subtitle }} <br /></p>

                <div v-if="counterLoaded" class="form well well-no-shadow counter-customisation">
                    <div class="flex-row">
                        <div class="pt-3 mr-2 typographies-paragraph-medium-semibold">
                            {{ label }}
                        </div>

                        <div class="ml-2 w-1 typographies-paragraph-medium-regular">
                            <label for="identcounter">{{ $l10n.__('Compteur') }}</label>
                            <el-input
                                v-model="counter.identcounter"
                                :class="[{ 'has-error': 'counter' in errors }]"
                                :maxlength="counter.identcounterzerofill"
                            />
                        </div>
                    </div>

                    <div class="flex-row">
                        <div v-if="'root' in errors" class="error-msg">
                            {{ errors.root }}
                        </div>
                        <div v-if="'counter' in errors" class="error-msg ml-3">
                            {{ errors.counter }}
                        </div>
                    </div>
                </div>

                <div v-else class="loader-container prelative mt-5">
                    <preloader :display="true" />
                </div>
            </div>
        </template>
        <template #footer>
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    @click="$emit('close-popup')"
                />
                <CompassButton
                    :label="$t.__('common.actions.save')"
                    type="primary"
                    class="ml-3"
                    @click="save()"
                />
            </div>
        </template>
    </CompassModal>
</template>

<script>
import Preloader from 'vcomponents/utilities/Preloader.vue';
import CounterFormMixin from './CounterFormMixin.js';

export default {
    components: {
        Preloader,
    },
    mixins: [CounterFormMixin],
    props: {
        counterId: {
            type: Number,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        glues: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            showModal: true,
        };
    },
};
</script>

<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;

.counter-draft-form {
    .dialog {
        &__default {
            padding-bottom: 24px;
            p {
                margin: 0;
            }
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 32px 24px 32px;
        }
    }
}

.counter-customisation {
    .has-error input {
        border-color: $red;
    }
    .error-msg {
        color: $red;
    }
}
</style>
